import ReactMarkdown from "react-markdown";


const CreatureCard = ({ data }) => {
  return (
    <div className="CreatureCard">
      <a className="CreatureCard__Image" href={`/creatures/${data.id}`} title={`Invited by ${data.author.firstName}`} style={{
        backgroundImage: `url(${data.img.large})`
      }}></a>
      <h3><a href={`/creatures/${data.id}`} >{data.name}</a></h3>
      <div className="CreatureCard__Description">
          <ReactMarkdown children={data.description} />
      </div>

    </div>
  );
};

export default CreatureCard;
